import { VisualSettingsStateInterface } from 'store/reducers/visualSettings/types';
import { PanelModal } from 'modules/workspace/components/panelSettingsApp';

export const initialVisualSettingsStoreState: VisualSettingsStateInterface = {
  SettingComponent: PanelModal,
};
